export default "__VITE_ASSET__BAUvC_Ph__"